require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTheme = exports.withTheme = exports.ThemeProvider = void 0;

var _reactThemeProvider = require("@callstack/react-theme-provider");

var _DefaultTheme = _interopRequireDefault(require("../styles/DefaultTheme"));

var _createTheming = (0, _reactThemeProvider.createTheming)(_DefaultTheme["default"]),
    ThemeProvider = _createTheming.ThemeProvider,
    withTheme = _createTheming.withTheme,
    useTheme = _createTheming.useTheme;

exports.useTheme = useTheme;
exports.withTheme = withTheme;
exports.ThemeProvider = ThemeProvider;